// Config records hold either a single value / { id, value } pair or a
// list of them.
// Multi valued data is shown as comma separated text across the config screens.
export const joinArrayValue = (value) =>
  Array.isArray(value)
    ? value
        .map((item) => (typeof item === "string" ? item.trim() : item))
        .filter((item) => item !== null && item !== undefined && item !== "")
        .join(", ")
    : value;

// Flattens a single or multi valued field into a plain list
const toList = (field, key) =>
  (Array.isArray(field) ? field : [field])
    .filter((item) => item !== null && item !== undefined && item !== "")
    .flatMap((item) =>
      item && typeof item === "object" ? [].concat(item[key] || []) : [item]
    )
    .filter((item) => item !== null && item !== undefined && item !== "");

// Label shown in the form fields - comma separated for multi valued records
export const getDisplayValue = (field) => {
  const values = toList(field, "value");
  return values.length ? values.join(", ") : null;
};

// Id kept for the payload - a single id stays a string, many ids stay an array
export const getIdValue = (field) => {
  const ids = toList(field, "id");
  if (!ids.length) return undefined;
  return ids.length === 1 ? ids[0] : ids;
};

// Ids for the array fields of the record - always a list
export const getIdList = (field) => toList(field, "id");
